import React from 'react'
import ReactDOM from 'react-dom'
import AcquireWebComponent from '../../framework/MaterialUI';
import { isEmpty } from 'lodash'
import { orderBy } from 'lodash'
import { map } from 'lodash'
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Sector } from 'recharts'
import { splitNumber } from '../../../utils/utility'

import "./PieChart.css"
const renderActiveShape = (props) => {
	const { cx, cy, innerRadius, outerRadius, startAngle, endAngle,
		fill } = props;
	return (
		<g>
			{/*
			<text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>{payload.name}</text>
			*/}
			<Sector
				cx={cx}
				cy={cy}
				innerRadius={innerRadius}
				outerRadius={outerRadius}
				startAngle={startAngle}
				endAngle={endAngle}
				fill={fill}
			/>
			<Sector
				cx={cx}
				cy={cy}
				startAngle={startAngle}
				endAngle={endAngle}
				innerRadius={outerRadius + 2}
				outerRadius={outerRadius + 10}
				fill={'#CCC'}
			/>
		</g>
	);
};

const CustomizedTooltip = React.createClass({
	render() {
		const {stroke, value, fieldName} = this.props
		return (
			<div className="recharts-default-tootip no-margin pt-5 pl-10 pr-10 pb-5" style={{background:'#FFFCDC' ,border:"solid 1px #ccc"}}>
				<p className="recharts-tooltip-label no-margin"></p>
				<ul className="recharts-tooltip-item-list no-padding no-margin">
					<li className="recharts-tooltip-item"
						style={{display: "inline", paddingTop:"4px", paddingBottom:"4px", width:"100%", stroke}}>
						<div style={{width:"auto", height:"20px", display:"block", overflow:"overlap", whiteSpace:"nowrap", textOverflow:"unset"}}>
							<p className="recharts-tooltip-label no-margin" style={{stroke}}></p>
							{fieldName} <strong>- {splitNumber(value)()}</strong>
						</div>{/*
						{linkurl && <span className="recharts-tooltip-item-name text-capital"><strong>{ linkurl}</strong></span>}
						{linkurl && <hr style={{borderTop: "1px solid #000", height:'1px', display:'block', margin:"5px 0"}} />}
						<span className="recharts-tooltip-item-value " style={{fontWeight: 300}}>
							{fieldName} <strong>- {splitNumber(value)()}</strong>
						</span>*/}
					</li>
				</ul>
			</div>
		)
		}
})

const styles={
	textOverflow :{
		whiteSpace:'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	}
}

class PieGraphicSection extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = {activeIndex: undefined}
  }

  onPieEnter(data, index) {
		this.setState({
			activeIndex: index,
			tooltip_name: data.payload.linkurl,
			tooltip_field_name: data.payload.linkurl,
			tooltip_value: data.payload.clicks,
			tooltip_stroke: data.payload.fill
		});
		const tooltips = ReactDOM.findDOMNode(this).getElementsByClassName('recharts-tooltip-wrapper')
		if (tooltips && tooltips.length > 0){
			const el = tooltips[0]
			el.style['visibility'] = "visible"
			el.style['padding-bottom'] = '0px'
		}
	}

	onPieLeave() {
		this.setState({
			activeIndex: -1
		})
		const tooltips = ReactDOM.findDOMNode(this).getElementsByClassName('recharts-tooltip-wrapper')
		if (tooltips && tooltips.length > 0){
			const el = tooltips[0]
			el.style['visibility'] = "hidden"
		}		
  }
  
  render() {
		//const COLORS = ['#050505', '#1C4456',  '#3888AB',  '#87B7CD',  '#AFCFDD'];
		const COLORS = ['#216E69', '#32A59D', '#56CBC4', '#99DFDD', '#BBEAE7']

		const { title, data, footer, subTitle, fieldDisplayFunc } = this.props
		const sortedData = orderBy(data, ['value'], ['desc'])
		const hideOverflowText = this.props.hideOverflow === true;

		let coloredData = {}
    map(sortedData, function(data, index){
      coloredData[data.linkurl] = COLORS[index % COLORS.length]
		})
		if (isEmpty(data)){
			return (
				<div style={{ float: "left", width: "100%", position: "relative", fontSize:"16px" }}>
					<div style={{ fontSize: '24px', lineHeight: '18px', fontWeight:'bold' }}>{title}</div>
					<div style={{ width: '100%', minHeight: '338px', textAlign: 'center', paddingTop: '160px', color: "#CDCDCD" }}>
						<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
					</div>		
				</div>
			)
		}else{
			return (
				<div style={{ float: "left", width: "100%", position: "relative", fontSize:"16px" }}>
					<div style={{ fontSize: '24px', lineHeight: '18px', fontWeight:'bold'}}>{title}</div>
					<div style={{ width: '40%', marginTop:'-10px', minHeight:'200px', display:"block", position:"relative", float: "right" }}>
						<ResponsiveContainer width="100%" height="80%" minHeight={250} >
							<PieChart>
								<Pie onMouseLeave={this.onPieLeave.bind(this)} onMouseEnter={this.onPieEnter.bind(this)} 
									activeShape={renderActiveShape} data={sortedData} fill="#8884d8" activeIndex={this.state.activeIndex}
									dataKey="clicks" isAnimationActive={false}  >
								{
									sortedData.map((entry, index) => <Cell key={"graphic-cell-" + index} fill={COLORS[index % COLORS.length]}/>)
								}
								</Pie>
								<Tooltip content={<CustomizedTooltip />} name={this.state.tooltip_name} 
									value={this.state.tooltip_value} stroke={this.state.stroke} 
									fieldName={this.state.tooltip_field_name} />
							</PieChart>
						</ResponsiveContainer>
					</div>
          <div className="light-grey-border-bottom pb-10" style={{width: '60%', top:"10px", position: "relative", float: "left", marginBottom:'30px' }}>
						{
							subTitle && (<div className="text-right mt-10 mb-10" style={{ color:subTitle === "&nbsp;" ? "#FFF" :"inherit", fontSize: "9pt" }}>
								<strong>{subTitle}</strong></div>)
						}
						{
							map(data, function (obj, idx) {
								return (
									<div key={"list-" + idx} className="light-grey-border-top mt-15 pt-15" style={{ height: "42px", display:"flex" }}>
										<div style={{flex:"0 0 20px", paddingTop:"3px"}}>
										{!isEmpty(coloredData) && <span className="span-legend" style={{ background: coloredData[obj.linkurl] }} >&nbsp;</span>}
										</div>
										<div style={hideOverflowText ? { ...styles.textOverflow, height:"24px", paddingRight:"10px", flex:"1 1"} : 
											{height:"18px", paddingRight:"10px", flex:"1 1 "}}>
											<span>{obj.linkurl}</span>
										</div>
										<div style={{flex:"0 0 40px", textAlign:"right"}}>{fieldDisplayFunc ? fieldDisplayFunc(obj) : obj.value}</div>
									</div>
								)
							})
						}
					</div>
					<br /><br />
					{(sortedData.length === 5 && (title === "DEMOGRAPHIC") ) && (<div className="mb-15"><br /><br /><br /><br /><br /><br /><br /></div>)}
					<div className="list-chart-footer" style={{marginTop:"290px"}}>
						{footer ? footer : <br />}
					</div>
				</div>
			)
		}
  }
}

export default PieGraphicSection


// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/PieGraphic.jsx